// extracted by mini-css-extract-plugin
export var examGrid = "exams-module--examGrid--uc4u6";
export var eyecharts = "exams-module--eyecharts--98CDI";
export var header = "exams-module--header--6h5aC";
export var lady = "exams-module--lady---+Zxc";
export var ladyWrapper = "exams-module--ladyWrapper--x++LC";
export var paragraph = "exams-module--paragraph--TDxt0";
export var redLine = "exams-module--redLine--VHc4f";
export var wrapper = "exams-module--wrapper--sZoCu";